import { getAPIEndPoint, URLS } from "../consts/APIEndpoints";
import { getResponse } from "../utils/common";
import { determineBucketSize } from "../utils/reports";

//CAMPAIGN DASHBOARD
export const getESDataForECD = async (params = {}) => {
  return await getResponse(
    `${getAPIEndPoint(URLS.ENTERPRISE_ADMIN_API)}/campaigns/es`,
    "get",
    undefined,
    params
  );
}

export const getDBDataForECD = async (params = {}) => {
  return await getResponse(
    `${getAPIEndPoint(URLS.ENTERPRISE_ADMIN_API)}/campaigns/db`,
    "get",
    undefined,
    params
  );
}

export const getEventsDataForECD = async (startDate, endDate, teamId) => {
  const aggregateBy = await determineBucketSize(startDate, endDate);
  const param = teamId ? { teamId } : {};
  const response = await getResponse(
    `${getAPIEndPoint(URLS.ENTERPRISE_ADMIN_API)}/events?type=sent,view,click,error&start_date=${startDate}&end_date=${endDate}&aggregate_by=${aggregateBy}`,
    "get",
    undefined,
    param
  );
  response.aggregateBy = aggregateBy;
  return response;
}

export const getRealtimeDataForECD = async (params = {}) => {
  return await getResponse(
    `${getAPIEndPoint(URLS.ENTERPRISE_ADMIN_API)}/realtime`,
    "get",
    undefined,
    params
  );
}

export const getThroughPutDataForECD = async (params = {}) => {
  return await getResponse(
    `${getAPIEndPoint(URLS.ENTERPRISE_ADMIN_API)}/throughput/es`,
    "get",
    undefined,
    params
  );
}

//TEAMS DASHBOARD

// returns count of total teams and total users
export async function getTeamStats(params = {}) {
  return await getResponse(
    `${getAPIEndPoint(URLS.ENTERPRISE_ADMIN_API)}/teams/db`,
    "get",
    undefined,
    params
  );
}


//SYSTEM NOTIFICATIONS

//onboard team for system notifications
export async function onboardTeamForSystemNotifications(body = {}) {
  return await getResponse(
    `${getAPIEndPoint(URLS.SYSTEM_NOTIFICATIONS)}/team/onboard`,
    "post",
    body,
  );
}
